import {EventEmitter} from 'eventemitter3'

export const assignmentEvent = new EventEmitter()

export const assignmentEventTypes = {
    ON_ROW_SELECTED: 'ON_ROW_SELECTED',
    ON_ROW_DESELECTED: 'ON_ROW_DESELECTED',
    ON_TOGGLE_PATHWAY: 'ON_TOGGLE_PATHWAY',
    ON_TOGGLE_STATIC_LIST: 'ON_TOGGLE_STATIC_LIST',
    ON_TOGGLE_HCP: 'ON_TOGGLE_HCP',
    ON_TOGGLE_SUPPORT_TEAM: 'ON_TOGGLE_SUPPORT_TEAM',
}

export function getAssignmentEventKey(tableKey, eventType) {
    if (!tableKey) {
        return ''
    }

    switch (eventType) {
        case assignmentEventTypes.ON_ROW_SELECTED:
            return `ON_ROW_SELECTED_${tableKey}`

        case assignmentEventTypes.ON_ROW_DESELECTED:
            return `ON_ROW_DESELECTED_${tableKey}`

        case assignmentEventTypes.ON_TOGGLE_PATHWAY:
            return `ON_TOGGLE_PATHWAY_${tableKey}`

        case assignmentEventTypes.ON_TOGGLE_STATIC_LIST:
            return `ON_TOGGLE_STATIC_LIST_${tableKey}`

        case assignmentEventTypes.ON_TOGGLE_HCP:
            return `ON_TOGGLE_HCP_${tableKey}`

        case assignmentEventTypes.ON_ROW_SUPPORT_TEAM:
            return `ON_TOGGLE_SUPPORT_TEAM_${tableKey}`

        default:
            return ''
    }
}

export function onRowSelectedListener(
    tableKey,
    eventType = assignmentEventTypes.ON_ROW_SELECTED,
    selectedRow,
) {
    if (!tableKey) {
        return
    }

    assignmentEvent.emit(
        `${getAssignmentEventKey(tableKey, eventType)}`,
        selectedRow,
    )
}

export function onRowDeselectedListener(
    tableKey,
    eventType = assignmentEventTypes.ON_ROW_DESELECTED,
    deselectedRow,
) {
    if (!tableKey) {
        return
    }

    assignmentEvent.emit(
        `${getAssignmentEventKey(tableKey, eventType)}`,
        deselectedRow,
    )
}

export function onToggleAssignmentFormListener(tableKey, eventType) {
    if (!tableKey) {
        return
    }

    assignmentEvent.emit(`${getAssignmentEventKey(tableKey, eventType)}`)
}

export function removeToggleAssignmentFormListener(tableKey, eventType) {
    if (!tableKey) {
        return
    }

    assignmentEvent.removeListener(
        `${getAssignmentEventKey(tableKey, eventType)}`,
    )
}
